<template>
    <div id="user-permission-popup">
        <div class="modal-content">
            <!-- Permissions -->
            <vx-card class="mt-base" no-shadow card-border>

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="flex items-center justify-between px-3 permissions-header ">
                            <div class="flex items-end">
                                <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
                                <span class="font-medium text-lg leading-none">{{$t('global.Permissions')}}</span>
                            </div>
                        </div>
                        <vs-divider />
                    </div>
                </div>
                <div class="block overflow-x-auto">
                    <div>
                        <vs-tabs position="left" v-if="permissionsData" v-model="activeTab">
                            <vs-tab v-for="(name, index) in Object.keys(permissionsData)" :label="$t(`permissions.${name}`)" :key="index">
                                <div class="block">
                                    <vs-alert v-if="permissionsData[name] && permissionsData[name].access" active="true" class="mb-4" v-bind="$iconData('icon-star', 'fi-rr-star')">
                                        {{ permissionsData[name].access[0].module_description}}
                                    </vs-alert>

                                    <div v-for="(perm, names, indexx) in permissionsData[name]">
                                        <div class="flex items-center">
                                            <div class="perm-text flex-auto">
                                                <h5>{{perm[0].permission_name}}</h5>
                                                <p class="text-sm">{{perm[0].permission_description}}</p>
                                            </div>
                                            <div class="perm-switch flex-initial">
                                                <vs-switch color="success" @click.prevent="changePermission($event, perm[0].module_id, perm[0].permission_id, perm[0].permission_enabled)" v-model="perm[0].permission_enabled" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check"/>
                                            </div>
                                        </div>
                                        <vs-divider v-if="indexx !== Object.keys(permissionsData[name]).length - 1"></vs-divider>
                                    </div>
                                </div>
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </div>

            </vx-card>
        </div>
    </div>
</template>

<script>
import EventBus from '../../store/eventBus'
import ErrorHandler from "@/utils/errorHandler";
import send from "@/utils/fetch";

export default {
    name: "UserPermissionEdit",
    props: ['popupData', 'popupType', 'popupButton'],
    data() {
        return {
            activeTab: 0,
            loadingEl: null,
            permissionsData: null,
            module_description: ''
        }
    },
    methods: {
        async changePermission(e, permission_module_id, permission_id, permission_state) {
            try {
                this.loadingEl = e.target.parentNode
                this.$vs.loading({
                    background: 'rgba(255,255,255,0.75)',
                    color: 'primary',
                    container: this.loadingEl,
                    scale: +'0.45'
                })
                // const response = await send(this.$url.user.update_permission, 'PUT', )
                const response = await this.$store.dispatch('edit', {url: this.$url.user.update_permission, data: {hash: this.popupData.hash, permission_module_id, permission_id}})
                const userPermissions = await this.$store.dispatch('fetch', {url: `${this.$url.user.get}?hash=${this.popupData.hash}`})
                await this.$store.dispatch('GET_USER_DATA') // Just for fun dynamic
                this.permissionsData = userPermissions.result.permissions
                this.$vs.loading.close(this.loadingEl)
            } catch(e) {
                this.$vs.loading.close(this.loadingEl)
                new ErrorHandler(e).send
            }
        },

        close() {
            EventBus.$emit('emitPopupEvent', {type: 'close'})
        }
    },
    async mounted() {
        try {
            const userPermissions = await this.$store.dispatch('fetch', {url: `${this.$url.user.get}?hash=${this.popupData.hash}`})
            this.permissionsData = userPermissions.result.permissions
            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss">
#user-permission-popup {
    margin-top: 0!important;
    .vs-tabs--content {
        padding: 0 10px;
        height: 300px;
        overflow-y: auto;
    }
    .vs-tabs--li button {
        font-size: 0.8rem;
        line-height: 1;
    }
    .vs-tabs-position-left .vs-tabs--li {
        padding: 0;
    }
    .vx-card {
        overflow: hidden;
        height: 350px;
        .vx-card__collapsible-content {
            .vx-card__body {
                padding: 0.7rem;
            }
        }
    }
    //.vx-card .vx-card__collapsible-content.vs-con-loading__container {
    //    height: 300px;
    //}
    .vs-tabs-position-left .con-ul-tabs {
        width: 210px;
        height: 300px;
        overflow-y: scroll;
    }
    .vs-divider {
        margin: 10px 0;
    }
    .mt-base {
        margin-top: 0!important;
    }
    .vs-tabs--li button {
        text-align: left;
    }
}
</style>
